var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v("Coopenaza")]),_vm._v(" "+_vm._s(_vm.year)+". ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }